import React, { useState, useEffect, useMemo, useCallback } from 'react';
import { Tabs, Tab } from '@material-ui/core';
import styled from 'styled-components';
import SessionCalibrationView from './SessionCalibrationView';
import { SessionStepProps, SessionStaticProps } from './SessionFlowBase';
import useSession from '../Util/useSession';
import { TSession } from './Sessions';
interface Props extends SessionStepProps {}

export const validCalibration = (c: string | undefined | null) => {
  if (!c) {
    return false;
  }
  const calib = JSON.parse(c);
  return (
    calib &&
    calib.K &&
    calib.K.length > 0 &&
    calib.k &&
    calib.k.length > 0 &&
    calib.R &&
    calib.R.length > 0 &&
    calib.t &&
    calib.t.length > 0
  );
};

const baseName = (url: string) => {
  return url.substring(url.lastIndexOf('/') + 1);
};

const SessionCalibration: React.FunctionComponent<Props> & SessionStaticProps = ({ sessionid, setNextEnabled }) => {
  const [value, setValue] = useState(0);
  const [valid, setValid] = useState<{ [key: string]: boolean }>({});
  const { session } = useSession(sessionid);
  //const [useInitKeypoints, setUseInitKeypoints] = useState<boolean>(false);
  //const [updateVideo] = useSessionUpdateVideoMutation();

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
  };

  /*
  const clearVideoKeypoints = useCallback((video: Video) => {
    const videoInfo: VideoInfo = { ...video.videoInfo };
    if (videoInfo) {
      delete videoInfo?.__typename;
      delete videoInfo.url;
    }
    updateVideo({
      variables: {
        id: sessionid,
        input: {
          id: video.id,
          url: video.url || "",
          sortOrder: video.sortOrder || 0,
          clickPoints: "",
          videoInfo: { ...videoInfo },
        },
      },
    });
  }, [sessionid, updateVideo]);
  */

  useEffect(() => {
    //All cameras have valid calibration values, we can enable the next button
    const validVids: number | undefined = session?.videos?.filter((video) => valid[video.url || '']).length;
    setNextEnabled(validVids === session?.videos?.length);
  }, [session, setNextEnabled, valid]);

  const isValid = useCallback(
    (url: string, isvalid: boolean) => {
      if (isvalid && valid[url] !== isvalid) {
        setValid({ ...valid, [url]: isvalid });
      }
    },
    [valid]
  );
  
  const sortedVideos = useMemo(() => {
    return (
      (session?.videos && session.videos.slice().sort((a, b) => (a.sortOrder || 0) - (b.sortOrder || 0))) || []
    );
  }, [session]);

  const calibrationViews = useMemo(
    () =>
      sortedVideos.map((video, index) => {
        return (
          <Container2 key={video.id} className="sciui-bg-p-5" show={index === value}>
            <SessionCalibrationView
              videoid={String(video.id)}
              show={index === value}
              pitchid={session?.pitch?.id ? String(session.pitch.id) : ''}
              isValid={isValid}
              useInitKeypoints={false}
            />
          </Container2>
        );
      }),
    [session, isValid, sortedVideos, value]
  );

  const videoTabs = useMemo(
    () => sortedVideos.map((video, index) => <Tab label={baseName(video.url || '')} key={index + ''} />),
    [sortedVideos]
  );

  return (
    <div>
      {/*
      <Button
        variant="contained"
        color="primary"
        onClick={() => {
          const curVideo = sortedVideos[value];
          clearVideoKeypoints(curVideo);
          window.location.reload();
        }}
        disabled={!sortedVideos[value].clickPoints}
      >
        Reset Points
      </Button>
      <Checkbox
        aria-label="use-init-keypoints"
        checked={useInitKeypoints}
        color="primary"
        onChange={() => {
          setUseInitKeypoints(!useInitKeypoints);
          window.location.reload();
        }}
      /> Use auto keypoint suggestion
      */}
      <Tabs value={value} onChange={handleChange} aria-label="screenshot-upload">
        {videoTabs}
      </Tabs>
      {calibrationViews}
    </div>
  );
};

type ContainerProps = {
  show: boolean;
};

const Container2 = styled.div<ContainerProps>`
  height: calc(100vh - 400px);
  width: 100%;
  flex: 1 1 auto;
  box-sizing: border-box;
  overflow: auto;
  display: ${(props) => (props.show ? 'inline-block' : 'none')};
`;

SessionCalibration.isComplete = (session: TSession) => {
  for (let video of session?.videos || []) {
    if (!video.url || !validCalibration(video.calibration)) {
      return false;
    }
  }
  return true;
};

export default SessionCalibration;
